var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTrash = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C1CBD6",
    d: "M48.85 13.903H31.184c-1.295 0-2.344-1.05-2.344-2.344V4.382C28.84 1.966 30.804 0 33.218 0h13.596c2.415 0 4.38 1.966 4.38 4.382v7.177c0 1.294-1.05 2.344-2.344 2.344zM33.527 9.215h12.979V4.688H33.527v4.527zm13.287-4.527h.001z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAE9E1",
    d: "M66.359 19.166c-.444-.48-1.068-.754-1.722-.754H15.4c-.655 0-1.28.273-1.723.754-.444.481-.666 1.126-.614 1.778l4.238 52.406c.302 3.729 3.467 6.65 7.204 6.65H55.53c3.738 0 6.902-2.921 7.204-6.65l4.238-52.406c.053-.652-.17-1.297-.613-1.778z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAE9E1",
    d: "M15.4 18.412c-.654 0-1.279.273-1.722.754-.444.481-.666 1.126-.614 1.778l4.238 52.406c.302 3.729 3.467 6.65 7.204 6.65H40.02V18.412H15.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAD2BC",
    d: "M73.196 20.013l-3.069-9.196c-.319-.957-1.214-1.602-2.222-1.602H12.13c-1.008 0-1.904.645-2.223 1.602L6.84 20.013c-.238.715-.118 1.501.322 2.112.44.612 1.148.974 1.901.974h61.91c.754 0 1.461-.362 1.902-.974.44-.61.56-1.397.322-2.112z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5AF89",
    d: "M51.615 72.809c-.04 0-.082 0-.124-.003-1.292-.067-2.285-1.17-2.218-2.463l2.2-42.25c.068-1.292 1.168-2.287 2.463-2.218 1.293.067 2.286 1.17 2.218 2.462l-2.2 42.25c-.065 1.251-1.1 2.222-2.339 2.222zM28.525 72.809c-1.236 0-2.27-.967-2.337-2.216l-2.306-42.25c-.07-1.293.92-2.397 2.213-2.468 1.292-.07 2.398.92 2.468 2.213l2.305 42.25c.07 1.292-.92 2.397-2.213 2.467-.043.003-.086.004-.13.004zM40.043 72.809c-1.294 0-2.344-1.05-2.344-2.344v-42.25c0-1.294 1.05-2.343 2.344-2.343 1.294 0 2.344 1.049 2.344 2.343v42.25c0 1.295-1.05 2.344-2.344 2.344z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5AF89",
    d: "M37.7 28.215v42.25c0 1.285 1.035 2.329 2.317 2.343V25.873c-1.282.014-2.318 1.056-2.318 2.342z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1CBD6",
    d: "M33.527 9.215V4.688h6.49V0h-6.799c-2.414 0-4.378 1.966-4.378 4.382v7.177c0 1.294 1.049 2.344 2.344 2.344h8.833V9.215h-6.49z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAD2BC",
    d: "M12.39 9.215c-1.008 0-1.904.645-2.224 1.602L7.1 20.013c-.238.715-.119 1.501.322 2.112.44.612 1.148.974 1.901.974h30.955V9.215H12.39z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trash.4f96e80f.svg";
export { ForwardRef as ReactComponent };